import { NotFoundMessage } from '@hendrx/core/common/components/messages/PageMessage/Messages/NotFoundMessage';
import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultNotFoundComponent: () => <NotFoundMessage />
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
